import script from "./SetMprValues.vue?vue&type=script&setup=true&lang=js"
export * from "./SetMprValues.vue?vue&type=script&setup=true&lang=js"

import "./SetMprValues.vue?vue&type=style&index=0&id=d265b3c8&lang=css"

const __exports__ = script;

export default __exports__